import { createAsyncThunk } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/nextjs";
import { API } from "aws-amplify";
import { SeoMissionCreateType } from "./types";

//create SEO mission
export const createSeoMissions = createAsyncThunk(
  "seoMissions/create",
  async (seoMissions: SeoMissionCreateType) => {
    const response = await API.post("seoMissions", "/seoMissions/create", {
      body: {
        ...seoMissions,
        // createdAt: new Date().toISOString(),
        // updatedAt: new Date().toISOString(),
      },
    });
    if (response.error) {
      Sentry.captureException(response.error);
    }
    return response;
  }
);

//get all SEO missions using project id
export const getSeoMissions = createAsyncThunk(
  "seoMissions/get",
  async ({
    limit,
    page,
    keyword,
    projectId,
    filters,
    sorting,
  }: {
    limit: number;
    keyword?: string;
    projectId?: string;
    page?: number;
    filters?: any;
    sorting?: any;


  }) => {

    const paramData = `limit=${limit}${page ? `&page=${encodeURIComponent(page)}` : '&page=0'} ${projectId ? `&projectId=${encodeURIComponent(projectId)}` : ""}${keyword ? `&keyword=${encodeURIComponent(keyword)}` : ""}${filters ? `&filters=${JSON.stringify(filters)}` : ""}${sorting ? `&sorting=${JSON.stringify(sorting)}` : ""}`;
    const data = await API.get(
      "seoMissions",
      `/seoMissions?${paramData}`,
      {}
    );
    if (data.error) {
      Sentry.captureException(data.error);
    }
    return data;
  }
);
// complete SEO mission
export const getCompleteSeoMission = createAsyncThunk(
  "seoMissions/getCompletedSeoMissions",
  async ({
    limit,
    page,
    keyword,
    projectId,
    filters,
    sorting,

  }: {
    limit: number;
    keyword?: string;
    projectId?: string;
    page?: number;
    filters?: any;
    sorting?: any;


  }) => {
    const paramData = `isCompleted=true&limit=${limit}${page ? `&page=${encodeURIComponent(page)}` : '&page=0'} ${projectId ? `&projectId=${encodeURIComponent(projectId)}` : ""}${keyword ? `&keyword=${encodeURIComponent(keyword)}` : ""}${filters ? `&filters=${JSON.stringify(filters)}` : ""}${sorting ? `&sorting=${JSON.stringify(sorting)}` : ""}`;
    const data = await API.get(
      "seoMissions",
      `/seoMissions?${paramData}`,
      {}
    );
    if (data.error) {
      Sentry.captureException(data.error);
    }
    return data;
  }
);

// get declined SEO mission
export const getDeclinedSeoMission = createAsyncThunk(
  "seoMissions/getDeclinedSeoMissions",
  async ({
    limit,
    page,
    keyword,
    projectId,
    filters,
    sorting,

  }: {
    limit: number;
    keyword?: string;
    projectId?: string;
    page?: number;
    filters?: any;
    sorting?: any;
  }) => {
    const paramData = `isDeclined=true&limit=${limit}${page ? `&page=${encodeURIComponent(page)}` : '&page=0'} ${projectId ? `&projectId=${encodeURIComponent(projectId)}` : ""}${keyword ? `&keyword=${encodeURIComponent(keyword)}` : ""}${filters ? `&filters=${JSON.stringify(filters)}` : ""}${sorting ? `&sorting=${JSON.stringify(sorting)}` : ""}`;
    const data = await API.get(
      "seoMissions",
      `/seoMissions?${paramData}`,
      {}
    );
    if (data.error) {
      Sentry.captureException(data.error);
    }
    return data;
  }
);



//decline SEO mission

export const declineSeoMission = createAsyncThunk(
  "seoMissions/decline",
  async ({
    id,
    projectId,

  }: {
    id: string;
    projectId: string;


  }) => {
    const response = await API.post("seoMissions", "/seoMissions/decline", {
      body: {
        id,
        projectId
      },
    });
    if (response.error) {
      Sentry.captureException(response.error);
    }
    return response;
  }
);

//delete SEO mission
export const deleteSeoMission = createAsyncThunk(
  "seoMissions/delete",
  async ({
    id,
    projectId,

  }: {
    id: string;
    projectId: string;

  }) => {
    const response = await API.post("seoMissions", `/seoMissions/delete`, {
      body: {
        id,
        projectId
      },
    });
    if (response.error) {
      Sentry.captureException(response.error);
    }
    return response;
  })

//activate SEO mission
export const activateSeoMission = createAsyncThunk(
  "seoMissions/activate",
  async ({
    id,
    projectId,

  }: {
    id: string;
    projectId: string;

  }) => {
    const response = await API.post("seoMissions", `/seoMissions/activate`, {
      body: {
        id,
        projectId
      },
    });
    if (response.error) {
      Sentry.captureException(response.error);
    }
    return response;
  }
);
